import {createTheme} from '@mui/material/styles';
import {themePoppins} from './themePoppins';
import {themePoppinsAero} from './themePoppinsAero';
import {themeDarkPoppins} from './themeDarkPoppins';
import {themeDarkPoppinsAero} from './themeDarkPoppinsAero';
import {generateMuiTheme} from './generateMuiTheme';

declare module '@mui/material/styles' {
   interface TypographyVariants {
      label: React.CSSProperties;
   }

   // allow configuration using `createTheme`
   interface TypographyVariantsOptions {
      label?: React.CSSProperties;
   }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
   interface TypographyPropsVariantOverrides {
      label: true;
      //   h3: false;
   }
}

export const themeNames = {
   classic: 'classic',
   aero: 'aero',
   custom: 'custom',
   // flat: 'flat',
} as const;

export const themes = {
   [themeNames.classic]: {
      light: createTheme(themePoppins),
      dark: createTheme(themeDarkPoppins),
   },
   [themeNames.aero]: {
      light: createTheme(themePoppinsAero),
      dark: createTheme(themeDarkPoppinsAero),
   },
   [themeNames.custom]: {
      light: createTheme(generateMuiTheme('light')),
      dark: createTheme(generateMuiTheme('dark')),
   },
   // [themeNames.flat]: {
   //    light: createTheme(themeFlatLight),
   //    dark: createTheme(themeFlatDark),
   // },
};
